// extracted by mini-css-extract-plugin
module.exports = {"back-button":"back_button__back-button___25hPo _type__vx_text-6_lighter___2qDBi","left-arrow":"back_button__left-arrow___hSevm","back-text":"back_button__back-text___3GOMw"};